<app-backgrop>
	<app-dialog class="max-w-9/10 w-150">
    <button class="size-[30px] [@media(min-height:935px)]:md:size-[50px] cursor-pointer absolute top-2 z-99 right-2 hovered-icon select-none" (pointerup)="playBtnClick(); closed.emit()">
      <img src="./assets-compressed/categories/icons/props/close.png" alt="" class="select-none">
      <img src="./assets-compressed/categories/icons/props/hover/close-hover.png" alt="" class="select-none">
    </button>
		<div class="flex flex-col items-center">
			<app-title class="text-center">Куда прислать<br><br>уведомление</app-title>

			<!-- Табы переключения между Телефон и Почта -->
			<div class="flex w-full mt-4 mb-2 md:mt-6 md:mb-4">
				<button type="button"
					class="flex-1 py-3 text-center text-base md:text-xl font-medium transition-all duration-200"
					[class.text-(--custom-color-1)]="!isEmailAuth" [class.cursor-pointer]="isEmailAuth"
					[class.border-b-2]="!isEmailAuth" [class.border-b-1]="isEmailAuth"
					[class.border-(--main-color)]="!isEmailAuth" [class.border-(--gray-color)]="isEmailAuth"
					[class.text-(--custom-color-4)]="isEmailAuth"
					[class.hover:text-(--custom-color-1)]="isEmailAuth" (click)="switchAuthType(false)">
					Телефон
				</button>
				<button type="button"
					class="flex-1 py-3 text-center text-base md:text-xl font-medium transition-all duration-200"
					[class.text-(--custom-color-1)]="isEmailAuth" [class.cursor-pointer]="!isEmailAuth"
					[class.border-b-2]="isEmailAuth" [class.border-b-1]="!isEmailAuth"
					[class.border-(--main-color)]="isEmailAuth" [class.border-(--gray-color)]="!isEmailAuth"
					[class.text-(--custom-color-4)]="!isEmailAuth"
					[class.hover:text-(--custom-color-1)]="!isEmailAuth" (click)="switchAuthType(true)">
					Почта
				</button>
			</div>

			<!-- Подпись в зависимости от типа -->
			<div class="text-center text-base md:text-xl text-(--custom-color-1) mb-2" [class.hidden]="">
				@if (!isEmailAuth) {
				Введите&nbsp;номер&nbsp;телефона
				} @else {
				Введите адрес электронной почты
				}
			</div>


			<!-- Поле телефона -->
        @if (!isEmailAuth) {
        <input
          class="h-12 bg-(--custom-color-14) rounded-md w-full px-4 placeholder-(--custom-color-4) focus:outline-none focus:ring-2 focus:ring-(--custom-color-1) mb-4"
          placeholder="+7 123 456 78 90" type="tel" id="phone" [formControl]="phone" (input)="onPhoneInput($event)"
          maxlength="15">
        }

			<!-- Поле email -->
        @if (isEmailAuth) {
        <input
          class="h-12 bg-(--custom-color-14) rounded-md w-full px-4 placeholder-(--custom-color-4) focus:outline-none focus:ring-2 focus:ring-(--custom-color-1) mb-4"
          placeholder="example@gmail.com" type="email" id="email" [formControl]="email" autocomplete="email">
        }

			<!-- Ошибка валидации -->
        @if (hasError) {
        <app-text-simple class="text-left text-(--custom-color-16) w-full pl-4 mb-4">
          {{ errorText }}
        </app-text-simple>
        }


        <app-text-simple class="text-(--custom-color-4) text-left mb-1 md:mb-4">
          <label class="flex items-start gap-4 cursor-pointer mb-1 md:mb-2 text-[12px]/[14px] md:text-base/[18px]" for="acceptTerms">
            <input
              type="checkbox"
              id="acceptTerms"
              [(ngModel)]="acceptTerms"
              class="peer sr-only"
            />
            <div class="mt-1 size-4 shrink-0 rounded-[4px] border-2 border-[#BFBFBF] text-black focus:ring-0 acceptTerms" >
              <svg viewBox="0 0 20 20" class="hidden size-3" fill="none">
                <path
                  d="M4 10L8 14L16 6"
                  stroke="white"
                  stroke-width="2.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </div>

            <span>
              Я принимаю
              <span class="underline text-(--custom-color-1)" (click)="$event.preventDefault(); $event.stopPropagation(); openPolicy()">
                Пользовательское соглашение
              </span>
              и 
              
              <span class="underline text-(--custom-color-1)" (click)="$event.preventDefault(); $event.stopPropagation();openAgreement()">
                Политику обработки персональных данных
              </span>. 
              Если мне не исполнилось 18 лет, я использую Платформу с согласия родителя (законного представителя).
            </span>
          </label>
        </app-text-simple>

        <app-text-simple class="text-(--custom-color-4) text-left mb-1 md:mb-4">
          <label class="flex items-start gap-4 cursor-pointer mb-1 md:mb-2 text-[12px]/[14px] md:text-base/[18px]" for="acceptSubs">
            <input
              type="checkbox"
              id="acceptSubs"
              [(ngModel)]="acceptSubs"
              class="peer sr-only"
            />
            <div class="mt-1 size-4 shrink-0 rounded-[4px] border-2 border-[#BFBFBF] text-black focus:ring-0 acceptSubs" >
              <svg viewBox="0 0 20 20" class="hidden size-3" fill="none">
                <path
                  d="M4 10L8 14L16 6"
                  stroke="white"
                  stroke-width="2.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </div>

            <span class="text-(--custom-color-1)">
              Я согласен получать уведомление о выходе новых частей Карьерного парка по {{ isEmailAuth ? 'почте' : 'СМС'}}.
            </span>
          </label>
        </app-text-simple>
			
			<!-- Кнопка отправки кода -->
      <app-button [disabled]="!(acceptTerms && acceptSubs)|| isWaiting" class="h-[40px] sm:h-[unset] mb-4 md:mb-8" [disabledColor]="'black'" 
        (click)="subs()">
        Напомнить
      </app-button>
			

		</div>
	</app-dialog>

</app-backgrop>

@if (showResult) {
  <app-backgrop class="z-2">
    <app-dialog class="flex md:min-h-[376px] w-[560px] max-w-9/10 p-2">
      <button class="size-[30px] [@media(min-height:935px)]:md:size-[50px] cursor-pointer absolute top-2 z-99 right-2 hovered-icon select-none" (pointerup)="playBtnClick(); closed.emit()">
        <img src="./assets-compressed/categories/icons/props/close.png" alt="" class="select-none">
        <img src="./assets-compressed/categories/icons/props/hover/close-hover.png" alt="" class="select-none">
      </button>
      <div class="w-3/10 my-12 mx-auto">
          <img src="./assets-compressed/images/check.png" alt="" class="select-none">
      </div>
      <div class="flex flex-col items-center mb-5 sm:mb-7 md:mb-10">
        <app-title class="text-(--custom-color-1)">Готово</app-title>
      </div>
      <div class="block w-[345px] max-w-full m-auto text-(--custom-color-1) text-center">

        <app-text-simple class="">Напомним, когда выйдет новая часть Карьерного парка.</app-text-simple>
      </div>
    </app-dialog>
  </app-backgrop>
}